export default "__VITE_ASSET__21bJtW4I__"